<template>
    <div class='page-content'>
        <div class='title'>
            <span>系统配置</span>
        </div>
        <div class='content'>
            <el-tabs v-model="tabs" v-if='dataCategoryList.length > 0' style="background-color: #fff">

                <!--添加或减少：移除或添加html结构->移除或添加监听的tabs中switch case
                    修改默认显示：tab栏默认显示tabs的值 想默认显示那个直接把下面的name替换掉
                    queryForm.orderStatus的值为默认请求的类型，空表示全部-->
                <el-tab-pane label="" name="null"></el-tab-pane>
                <el-tab-pane :label="'全部'" name="zero"></el-tab-pane>
                <!--                (${computeAuditStatus[`status_${index}`]})-->
                <el-tab-pane v-for="(item,index) in dataCategoryList" :label="`${item.categoryName}`" :name='"status_"+index'></el-tab-pane>
            </el-tabs>
            <div class='content-tag'>
<!--                <div v-if="dataCategoryList.length > 0">-->
<!--                    <el-tag-->
<!--                        v-for="(item,index) in dataCategoryList"-->
<!--                        :key="index"-->
<!--                        @click="getSearchConfig(item.id)"-->
<!--                        effect="plain">-->
<!--                        {{ item.categoryName }}-->
<!--                    </el-tag>-->
<!--                </div>-->
                <el-tag
                v-for="(item,index) in dataList"
                :key="index"
                @click="getSysConfig(item.id)"
                effect="plain">
                    {{ item.dictName }}
                </el-tag>
            </div>
            <div class='content-form'>
                <el-table
                    :data="valueList"
                    size="small"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="dataName"
                        align="center"
                        label="名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="dataValue"
                        align="center"
                        label="键值"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="dataLabel"
                        align="center"
                        label="标签"
                        width="450">
                        <template slot-scope="scope">
                            <div class="form-input">
                                <el-input v-model="scope.row.dataLabel" size="small" v-if="scope.row.dataType == 1"></el-input>
                                <el-input type="textarea" v-model="scope.row.dataLabel" size="small" v-else-if="scope.row.dataType == 2"></el-input>
                                <el-radio-group style="flex: 1;margin: auto 0;" v-model="scope.row.dataLabel" v-else-if="scope.row.dataType == 3">
                                    <el-radio v-for="(item,key) in scope.row.dataLists" :key="key" :label="item.key">{{item.value}}</el-radio>
                                </el-radio-group>
                                <el-checkbox-group style="flex: 1;margin: auto 0;" v-model="scope.row.dataLabel" v-else-if="scope.row.dataType == 4">
                                    <el-checkbox v-for="(item,key) in scope.row.dataLists" :key="key" :label="item.key">{{item.value}}</el-checkbox>
                                </el-checkbox-group>
                                <el-select
                                    style="flex: 1;"
                                    v-model="scope.row.dataLabel"
                                    v-else-if="scope.row.dataType == 5 || scope.row.dataType == 6"
                                    size="small"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item,index) in scope.row.dataLists"
                                        :key="index"
                                        :label="item.value"
                                        :value="item.key"
                                    > </el-option>
                                </el-select>
                                <el-date-picker
                                    v-else-if="scope.row.dataType == 7"
                                    style="flex: 1;"
                                    size="small"
                                    v-model="scope.row.dataLabel"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else-if="scope.row.dataType == 8"
                                    v-model="scope.row.dataLabel"
                                    style="flex: 1;"
                                    size="small"
                                    format='yyyy-MM-dd'
                                    value-format='yyyy-MM-dd'
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                                <el-time-picker
                                    v-else-if="scope.row.dataType == 9"
                                    v-model="scope.row.dataLabel"
                                    size="small"
                                    format='HH:mm:ss'
                                    value-format='HH:mm:ss'
                                    style="flex: 1;"
                                    :picker-options="{
                                    selectableRange: '00:00:00 - 23:59:59'}"
                                    placeholder="选择时间">
                                </el-time-picker>
                                <el-time-picker
                                    v-else-if="scope.row.dataType == 10"
                                    is-range
                                    v-model="scope.row.dataLabel"
                                    range-separator="至"
                                    size="small"
                                    format='HH:mm:ss'
                                    style="flex: 1;"
                                    value-format='HH:mm:ss'
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    placeholder="选择时间范围">
                                </el-time-picker>
                                <el-date-picker
                                    v-else-if="scope.row.dataType == 11"
                                    v-model="scope.row.dataLabel"
                                    type="datetime"
                                    style="flex: 1;"
                                    placeholder="选择日期时间"
                                    size="small"
                                    format='yyyy-MM-dd HH:mm:ss'
                                    value-format='yyyy-MM-dd HH:mm:ss'>
                                </el-date-picker>
                                <el-date-picker
                                    v-else-if="scope.row.dataType == 12"
                                    v-model="scope.row.dataLabel"
                                    style="flex: 1;"
                                    size="small"
                                    format='yyyy-MM-dd HH:mm:ss'
                                    value-format='yyyy-MM-dd HH:mm:ss'
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                                <div v-else-if="scope.row.dataType == 13" style="flex: 1;display: flex;align-items: center;">
                                    <el-input v-model="scope.row.dataLabel" size="small"></el-input>
                                    <el-color-picker v-model="scope.row.dataLabel" size="medium" style="margin-left: 2px;"></el-color-picker>
                                </div>
                                <div v-else-if="scope.row.dataType == 14" style="flex: 1;display: flex;align-items: center;">
                                    <el-input v-model="scope.row.dataLabel" size="small"></el-input>
                                    <el-button type="primary" size="small" style="margin-left: 2px;" @click="uploadImages(scope.row.id)">上传图片
                                        <!-- <el-upload :action="action" :headers="header" v-show="false" :before-upload="beforeImageUpload" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                            :http-request="uploadImage">
                                            <el-button type="primary" size="small" class="as">上传</el-button>
                                        </el-upload> -->
                                    </el-button>
                                </div>
                                <div v-else-if="scope.row.dataType == 15" style="flex: 1;display: flex;align-items: center;">
                                    <el-input v-model="scope.row.dataLabel" size="small"></el-input>
                                    <el-button type="primary" size="small" style="margin-left: 2px;" @click="uploadImages1(scope.row.id)">上传文件
                                        <!-- <el-upload action="#" :headers="header" v-show="false" ref="uploads1" class="avatar-uploader" :show-file-list="false"
                                            :http-request="uploadImage1">
                                            <el-button type="primary" size="small" class="as1">上传</el-button>
                                        </el-upload> -->
                                    </el-button>
                                </div>
                                <el-input v-model="scope.row.dataLabel" size="small" v-else></el-input>
                                <el-button type="primary" style="margin-left: 10px" size="small" @click="editValue(scope.row)">保存</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remarks"
                        align="center"
                        label="说明">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 上传调用部分 -->
        <el-upload :action="action" :headers="header" v-show="false" :before-upload="beforeImageUpload" ref="uploads" class="avatar-uploader" :show-file-list="false"
                   :http-request="uploadImage">
            <el-button type="primary" size="small" class="as">上传</el-button>
        </el-upload>
        <el-upload action="#" :headers="header" v-show="false" ref="uploads1" class="avatar-uploader" :show-file-list="false"
                   :http-request="uploadImage1">
            <el-button type="primary" size="small" class="as1">上传</el-button>
        </el-upload>
    </div>
</template>

<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { margin } from 'tailwindcss/lib/plugins';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
export default {
    data() {
        return {
            dataList: [],
            valueList: [],
            dataCategoryList: [],
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            id:'',
            ids:"",
            tabs: 'zero',
        };
    },
    watch:{
        tabs(val){
            // switch (val) {
            if(val == 'zero'){
                this.getSearchConfig()
                return
            }
            for (let i = 0; i < this.dataCategoryList.length; i++) {
                if(val == 'status_'+i){
                    this.getSearchConfig(this.dataCategoryList[i].id);
                    break;
                }
            }
        },
    },
    created() {
        this.getSysConfigAll();
        this.getCategoryList();
    },
    methods: {
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        uploadImages(id) {
            this.id = id
            this.$refs.uploads.$el.querySelector(".as").click()
            // console.log(this.$refs.uploads)
        },
        uploadImages1(id) {
            this.id = id
            this.$refs.uploads1.$el.querySelector(".as1").click()
            // console.log(this.$refs.uploads)
        },
        //上传缩略图
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg)
                    for (let item of this.valueList) {
                        if(item.id == this.id){
                            console.log(item)
                            item.dataLabel = res.url
                        }
                    }
                    this.id = ''
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        uploadImage1(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            upload('/mpp/file/upload', formData).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg)
                    for (let item of this.valueList) {
                        if(item.id == this.id){
                            item.dataLabel = res.url
                        }
                    }
                    this.id = ''
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        margin() {
            return margin
        },
        getDictDateTypeEnum(){
            for (const key in this.valueList) {
                switch (this.valueList[key].dataType) {
                    case 3:
                    case 5:
                        let array = this.valueList[key].dataSource.split(',')
                        let array1 = []
                        for (const key in array) {
                            let array2 = array[key].split(':')
                            array1.push({
                                key: array2[0],
                                value: array2[1],
                            })
                        }
                        console.log(array1)
                        this.valueList[key].dataLists = array1
                        break;
                    case 4:
                        let array2 = this.valueList[key].dataSource.split(',')
                        let array3 = []
                        for (const key in array2) {
                            let array4 = array2[key].split(':')
                            array3.push({
                                key: array4[0],
                                value: array4[1],
                            })
                        }
                        console.log(array3)
                        this.valueList[key].dataLabel = this.valueList[key].dataLabel.split(",")
                        this.valueList[key].dataLists = array3
                        break;
                    // case 5:
                    //     let array4 = this.valueList[key].dataSource.split(',')
                    //     let array5 = []
                    //     for (const key in array4) {
                    //         let array6 = array4[key].split(':')
                    //         array5.push({
                    //             key: array6[0],
                    //             value: array6[1],
                    //         })
                    //     }
                    //     // this.valueList[key].dataLabel = this.valueList[key].dataLabel * 1
                    //     this.valueList[key].dataLists = array5
                    //     console.log(this.valueList[key])
                    //     break;
                    case 6:
                        get('/mpp/utils/getEnum',{enumType: this.valueList[key].dataSource}).then((res)=>{
                            if(res.success){
                                this.valueList[key].dataLists = res.enumList
                                this.valueList[key].dataLabel = this.valueList[key].dataLabel * 1
                                console.log(this.valueList)
                            }
                        })
                        break;
                    case 8:
                    case 10:
                    case 12:
                        this.valueList[key].dataLabel = this.valueList[key].dataLabel.split(",")
                        break;
                    // case 10:
                    //     this.valueList[key].dataLabel = this.valueList[key].dataLabel.split(",")
                    //     console.log(this.valueList[key])
                    //     break;
                    // case 12:
                    //     this.valueList[key].dataLabel = this.valueList[key].dataLabel.split(",")
                    //     console.log(this.valueList[key])
                    //     break;
                }
            }
        },
        getSysConfigAll(){
            get('/mpp/dict/findAllIsShow',).then((res)=>{
                if(res.success){
                    this.dataList = res.list
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        getCategoryList(){
            get('/mpp/dictcategory/findAll',).then((res)=>{
                if(res.success){
                    this.dataCategoryList = res.list
                }
            })
        },
        getSearchConfig(id){
            let obj = {}
            if(id){
                obj.dictCategory = id
            }
            get('/mpp/dict/findAllIsShow', obj).then((res)=>{
                if(res.success){
                    this.dataList = res.list
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        getSysConfig(id = ''){
            if(id != ''){
                this.ids = id;
            }
            get('/mpp/dict/findValueIsShow',{dictId:this.ids}).then((res)=>{
                if(res.success){
                    for (let iterator of res.value) {
                        iterator.dataLists = []
                    }
                    this.valueList = res.value
                    this.getDictDateTypeEnum();
                }
            })
        },
        editValue(e){
            let params = e
            delete params.dataLists
            switch (params.dataType) {
                case 4:
                case 8:
                case 10:
                case 12:
                    params.dataLabel = params.dataLabel.join(',')
                    break;
                // case 8:
                //     params.dataLabel = params.dataLabel.join(',')
                //     break;
                // case 10:
                //     params.dataLabel = params.dataLabel.join(',')
                //     break;
                // case 12:
                //     params.dataLabel = params.dataLabel.join(',')
                //     break;
            }
            post('/mpp/dict/editValue',params).then((res)=>{
                if(res.success){
                    this.$message.success(res.msg)
                    this.getSysConfig()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
    }
};
</script>

<style lang='scss' scoped>
.page-content{
    padding: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.title{
    width: 100%;
    height: 60px;
    padding-left: 28px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    font-size: 18px;
}
.content{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    .content-tag{
        width: 100%;
        padding: 10px 0 10px 10px;
        background-color: #eee;
        ::v-deep .el-tag{
            margin-right: 5px;
            margin-bottom: 5px;
        }
    }
    .content-form{
        flex: 1;
        width: 100%;
        padding-top: 10px;
        .form-input{
            display: flex;
        }
    }
}

::v-deep .el-tag{
    cursor: pointer;
}
</style>
